import React, { useEffect, useRef, useState } from "react";
import { zegoEngine } from "../../zegoCallConfig"; // Instance Zego
import { loginToZego } from "../../components/utils/zegoLoginVC"; // Fungsi login

const SimpleVideoCallForm: React.FC = () => {
  const localVideoRef = useRef<HTMLDivElement>(null);
  const remoteVideosRef = useRef<HTMLDivElement>(null);

  const [userID, setUserID] = useState("");
  const [userName, setUserName] = useState("");
  const [roomID, setRoomID] = useState("");

  const [isJoined, setIsJoined] = useState(false);
  const [isCallStarted, setIsCallStarted] = useState(false);

  const [streamID, setStreamID] = useState("");
  const localStream = useRef<any>(null);
  const remoteStreams = useRef<Map<string, any>>(new Map());

  const zg = zegoEngine;

  useEffect(() => {
    if (!isJoined) return;

    // Listen remote stream update
    zg.on("roomStreamUpdate", async (roomID, updateType, streamList) => {
      if (updateType === "ADD") {
        for (const streamInfo of streamList) {
          const remoteStream = await zg.startPlayingStream(streamInfo.streamID);

          // Buat video element
          const videoEl = document.createElement("video");
          videoEl.autoplay = true;
          videoEl.playsInline = true;
          videoEl.srcObject = remoteStream;
          videoEl.style.width = "300px";
          videoEl.style.height = "250px";
          videoEl.style.background = "#ccc";
          videoEl.style.margin = "5px";

          remoteStreams.current.set(streamInfo.streamID, {
            stream: remoteStream,
            element: videoEl,
          });

          if (remoteVideosRef.current) {
            remoteVideosRef.current.appendChild(videoEl);
          }
        }
      } else if (updateType === "DELETE") {
        for (const streamInfo of streamList) {
          zg.stopPlayingStream(streamInfo.streamID);
          const streamData = remoteStreams.current.get(streamInfo.streamID);
          if (streamData?.element && remoteVideosRef.current) {
            remoteVideosRef.current.removeChild(streamData.element);
          }
          remoteStreams.current.delete(streamInfo.streamID);
        }
      }
    });

    return () => {
      zg.off("roomStreamUpdate");
    };
  }, [isJoined]);

  const handleJoinRoom = async () => {
    if (!userID || !userName || !roomID) {
      alert("Harap isi semua data!");
      return;
    }

    const loginResult = await loginToZego(userID, userName, roomID);
    if (loginResult) {
      console.log("✅ Berhasil masuk ke room");
      // streamID.current = streamID;
      console.log(streamID, 'streamID-custom')
      setIsJoined(true);
    } else {
      alert("Gagal login ke Zego");
    }
  };

  const handleStartCall = async () => {
    localStream.current = await zg.createZegoStream();

    // Render local video
    const videoEl = document.createElement("video");
    videoEl.autoplay = true;
    videoEl.playsInline = true;
    videoEl.muted = true; // wajib muted biar ga feedback
    videoEl.srcObject = localStream.current.mediaStream;
    videoEl.style.width = "300px";
    videoEl.style.height = "250px";
    videoEl.style.background = "#ccc";

    if (localVideoRef.current) {
      localVideoRef.current.innerHTML = ""; // clear
      localVideoRef.current.appendChild(videoEl);
    }

    zg.startPublishingStream(streamID, localStream.current);
    setIsCallStarted(true);
  };

  const handleLeaveCall = () => {
    if (localStream.current) {
      zg.stopPublishingStream(streamID);
      zg.destroyStream(localStream.current);
    }
    zg.logoutRoom(roomID);

    // Hapus semua video remote
    if (remoteVideosRef.current) {
      remoteVideosRef.current.innerHTML = "";
    }
    remoteStreams.current.clear();

    if (localVideoRef.current) {
      localVideoRef.current.innerHTML = "";
    }

    setIsJoined(false);
    setIsCallStarted(false);
  };

  return (
    <div style={{ maxWidth: "900px", margin: "auto", textAlign: "center" }}>
      <h2>Form Video Call Sederhana</h2>

      {!isJoined && (
        <div style={{ marginBottom: "20px" }}>
          <input
            type="text"
            placeholder="User ID"
            value={userID}
            onChange={(e) => setUserID(e.target.value)}
            style={{ padding: "8px", margin: "5px" }}
          />
          <input
            type="text"
            placeholder="Stream ID"
            value={streamID}
            onChange={(e) => setStreamID(e.target.value)}
            style={{ padding: "8px", margin: "5px" }}
          />
          <input
            type="text"
            placeholder="Username"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            style={{ padding: "8px", margin: "5px" }}
          />
          <input
            type="text"
            placeholder="Room ID"
            value={roomID}
            onChange={(e) => setRoomID(e.target.value)}
            style={{ padding: "8px", margin: "5px" }}
          />
          <br />
          <button
            onClick={handleJoinRoom}
            style={{
              padding: "10px 20px",
              marginTop: "10px",
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
            }}
          >
            Join Room
          </button>
        </div>
      )}

      {isJoined && !isCallStarted && (
        <div>
          <p>🔔 Siap untuk panggilan.</p>
          <button
            onClick={handleStartCall}
            style={{
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
            }}
          >
            Start Call
          </button>
        </div>
      )}

      {isCallStarted && (
        <div style={{ marginTop: "20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h4>Local Video</h4>
              <div
                ref={localVideoRef}
                style={{
                  width: "300px",
                  height: "250px",
                  backgroundColor: "#ccc",
                }}
              ></div>
            </div>
            <div>
              <h4>Remote Video(s)</h4>
              <div
                ref={remoteVideosRef}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  minHeight: "250px",
                  backgroundColor: "#f5f5f5",
                  padding: "5px",
                }}
              ></div>
            </div>
          </div>
          <button
            onClick={handleLeaveCall}
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#dc3545",
              color: "#fff",
              border: "none",
            }}
          >
            Leave Call
          </button>
        </div>
      )}
    </div>
  );
};

export default SimpleVideoCallForm;
